<template>
  <div class="block text-center home-carousel">
    <el-carousel height="220px" :interval="timer">
      <el-carousel-item v-for="(item,index) in tabs" :key="index">
        <router-link class="carousel-link" :to="'/code/' + item.type">
          <h4>{{item.label}}</h4>
          <el-text>{{item.html.history[0]}}</el-text>
        </router-link>
      </el-carousel-item>
    </el-carousel>
  </div>
  <div class="home-tabs">
    <h3>代码示例</h3>
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="tab in tabs" :key="tab.label" :name="tab.type" :label="tab.label">
        <el-skeleton v-if="!tab.toHtml" :rows="5" animated />
        <template v-if="tab.toHtml">
          <pre v-for="(content, index) in tab.contents" :key="index">
            <code :class="['language-'+tab.type]" v-html="content"></code>
          </pre>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
  <footer class="footer-nav">
    <p class="text-center beian">
<a class="el-link el-link-default" href="https://beian.miit.gov.cn/#/" target="_blank">鄂ICP备19029495号-1</a><a class="el-link el-link-default" href="https://beian.mps.gov.cn/#/query/webSearch?code=42018502007226" rel="noreferrer" target="_blank"><img src="/beian.png" />鄂公网安备42018502007226</a>
    </p>
  </footer>
</template>

<script setup name="IndexView">
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

const timer = ref(5000)
const activeName = ref("c")
const store = useStore()
const tabs = store.state.tabs

onMounted(() => {
  tabs.forEach(tab => {
    if(tab.toHtml){
      return
    }
    tab.contents.forEach((content, i, contents) => {
      contents[i] = window.hljs.highlight(content, {language: tab.type}).value
    })
    tab.toHtml = true
  })
})
</script>
<style scoped>
.carousel-link {
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 1em 2em;
  text-decoration: none;
  color: #333;
  background-color: #ccd7ff;
  text-align: left;
}
.carousel-link h4 {
  padding-left: 1em;
  margin-top: 1em;
  width: 100%;
}
.carousel-link span {
  line-height: 1.5em;
  display: -webkit-box;
  margin: 0.5em;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  text-indent: 2em;
  overflow: hidden;
  text-overflow: ellipsis;
}
.home-tabs {
  padding: 1em;
}
.home-tabs h3 {
  padding: 0 1em;
  text-align: left;
  color: #555;
}
code {
  display: block;
  text-align: left;
  line-height: 1.5em;
  padding: 1em 0;
}
pre {
  border: 1px solid #eee;
  border-radius: 0.5em;
  padding-left: 2em;
  overflow: hidden;
  box-shadow: 1px 1px 2px #ccc inset;
}
.beian {
  color: #888;
  margin-top: 2em;
  font-size: smaller;
}
.beian a {
  font-size: smaller;
}
.beian a img {
  width:1em;
  margin:0 0.5em;
}
</style>
